import { CancelTokenSource } from 'axios';
import apiClient, { makeQueryString, WrappingApiClient } from 'libs/api/apiClient';
import { TCreateQuizState, TCustomerOpinion } from 'modules/learning';
import { TVerifyPaymentLog, TVerifymobilePaymentLog, TCancelPaymentLog } from 'modules/mentoring';
import { TSendSMS, TReceiveSMS } from 'modules/user';

// leargning > quiz
export const getQuizDetail = (id: number) => {
  return WrappingApiClient(apiClient.get(`/drill/quiz/${id}`));
};

export const createQuiz = (params: TCreateQuizState) => {
  return WrappingApiClient(apiClient.post('/drill/quiz', params));
};

export const updateQuiz = (params: TCreateQuizState, id: number) => {
  return WrappingApiClient(apiClient.put(`/drill/quiz/${id}`, params));
};

export const deleteQuiz = (id: number) => {
  return WrappingApiClient(apiClient.delete(`/drill/quiz/${id}`));
};

//채점하기
export const gradingQuiz = (params: any) => {
  return WrappingApiClient(apiClient.post(`/drill/quiz/grade`, params));
};
//채점할 때 멤버십 유저인지 확인
export const checkMenbershipUser = () => {
  return WrappingApiClient(apiClient.get('/drill/membership_user'));
};
//채점눌렀을 때 멤버십 유저가 맞으면 해설 body 받기
export const getQuizCommentary = (id: number) => {
  return WrappingApiClient(apiClient.get(`/drill/quiz/explanation/${id}`));
};

//푼 문제인지 여부
export const alreadyGradedQuiz = (id: number) => {
  return WrappingApiClient(apiClient.get(`/drill/user/quiz/${id}`));
};

//다시풀기 눌렀을 때 기존 풀이 날라가도록
export const deleteGradedAnswer = (id: number) => {
  return WrappingApiClient(apiClient.delete(`/drill/user/solve_again/${id}`));
};

//모달 : 그룹명 관련
export const getQuizGroup = () => {
  return WrappingApiClient(apiClient.get('/drill/quiz/groups'));
};

export const createQuizGroup = (params: { name: string }) => {
  return WrappingApiClient(apiClient.post('/drill/quiz/group', params));
};

export const delQuizGroup = (id: number) => {
  return WrappingApiClient(apiClient.delete(`/drill/quiz/group/${id}`));
};

//모달 : 주제/예제명 관련
export const getQuizExamples = () => {
  return WrappingApiClient(apiClient.get('/drill/board/examples'));
};

//의견보내기
export const sendCustomerOpinion = (params: TCustomerOpinion) => {
  return WrappingApiClient(apiClient.post('/drill/customer_inquiry', params));
};

//샘플 문제 id값 받기
export const getSampleQuizId = () => {
  return WrappingApiClient(apiClient.get('drill/sample_quiz'));
};

//결제
export const getDrillPaymentInfo = () => {
  return WrappingApiClient(apiClient.get('/drill/user_payment'));
};

export const drillVerifyPayment = (param: TVerifyPaymentLog, cancel?: CancelTokenSource) => {
  return apiClient.post('/drill/payment/verify', param, {
    cancelToken: cancel?.token,
  });
};
export const drillVerifyMobilePayment = (params: TVerifymobilePaymentLog, cancel?: CancelTokenSource) => {
  return apiClient.get(`/drill/payment/verify?${makeQueryString(params)}`, {
    cancelToken: cancel?.token,
  });
};

//🌸 환불
export const cancelPayment = (params: TCancelPaymentLog, cancel?: CancelTokenSource) => {
  return apiClient.post('/credit/payment/cancel', params, {
    cancelToken: cancel?.token,
  });
};

// 🌸
//파라미터값으로 finance, consulting 구분
export const getMentoringTicketData = ({ field }: { field: { mentoring_field: string } }) => {
  return apiClient.get(`/credit/mentoring_ticket?${makeQueryString(field)}`);
};
export const getMembershipPaymentDate = () => {
  return apiClient.get('drill/extend/pass');
};

// export const createPaymentLog
//learning > board
//learning > board
type TGetSubThemeDetail = {
  subject: string;
  is_example: string;
  mentoring_field: string;
};

export const getSubThemeList = (board_id: string) => {
  return WrappingApiClient(apiClient.get(`/drill/board/${board_id}`));
};

export const getSubThemeDetail = (params: TGetSubThemeDetail) => {
  return WrappingApiClient(apiClient.get(`/drill/boards?${makeQueryString(params)}`));
};
